import { call } from "redux-saga/effects";

export default function* logout(auth0) {
  yield call([
    auth0,
    auth0.logout,
    {
      returnTo: window.location.origin,
    },
  ]);
}
